<template>
<div class="categories">
	<div class="cat-panel clearfix hideme" v-for="(category, key) in categories" :class="category.class" v-on:click="openCategory(key)">
		<img :src="loadImage(category.fileName)" :alt="category.friendly" :class="{'col-xs-12 hidden-sm hidden-md hidden-lg nopadding' : category.fileNameLarge}">
		<img v-if="category.fileNameLarge" :src="loadImage(category.fileNameLarge)" :alt="category.friendly" class="hidden-xs col-sm-12 col-md-12 col-lg-12 nopadding">
		<div class="cat-title">{{category.friendly}}</div>
	</div>
</div>
</template>

<script>

export default {
	name: 'categories',
	props: {
		categories: {
			required: true,
			type: Object
		}
	},
	data: function() {
		return {
			imageCount: 50,
			index: 0,
			rippleSize: 100,
			rippleAnimation: '',
			categoryId: ''
		}
	},
	methods: {
		loadImage(img) {
			return require('../assets/' + img + '.jpg')
		},
		openCategory(categoryId) {
			this.categoryId = categoryId;
			console.log('openCategory')
			if (!this.categoryId) { return; }
			this.$emit('clicked', this.categoryId);
		}
	}
}
</script>


// WEBPACK FOOTER //
// Categories.vue?b1822346